var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 22H3.66666C2.19389 22 0.999991 20.8247 1 19.375L1.0001 3.62499C1.00011 2.17525 2.19402 1 3.66677 1H15.6671C17.1398 1 18.3337 2.17526 18.3337 3.62501V8.87502M5.66708 6.25001H13.6671M5.66708 10.1875H13.6671M5.66708 14.125H9.66708M19.3633 12.4917L21.5086 14.6369M14 20L16.6018 19.4758C16.7399 19.4479 16.8667 19.3799 16.9663 19.2803L22.7907 13.4529C23.0699 13.1736 23.0697 12.7207 22.7903 12.4415L21.5565 11.2092C21.2771 10.9301 20.8244 10.9303 20.5453 11.2096L14.7203 17.0375C14.6209 17.137 14.553 17.2635 14.5252 17.4014L14 20Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportBot);
export default __webpack_public_path__ + "static/media/report-bot.493a47160b6f2de7c750b06bcfd05279.svg";
export { ForwardRef as ReactComponent };